export const CLEAN_STATE = 'CLEAN_STATE'
export const UPDATE_ORDER_FROM_UI = 'UPDATE_ORDER_FROM_UI'
export const SET_ORDER_LIST = 'SET_ORDER_LIST'
export const UPDATE_ORDER_FROM_SERVER = 'UPDATE_ORDER_FROM_SERVER'
export const SET_FILTER_CONFIG = 'SET_FILTER_CONFIG'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_NEW_ORDER = 'SET_NEW_ORDER'
